import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
// styled-components.
// -----------------------------------------------------------------------------
export const TabLabelBoxed = styled.button `
  ${({ mode, selected }) => css `
    /* Display & Box Model */
    border: 1px solid transparent;
    border-bottom: 0;
    border-radius: 0;
    border-top-style: solid;
    border-top-width: 4px;
    margin: 0;
    padding: ${getSpace('m')} ${getSpace('2xl')};

    /* Color */
    background-color: transparent;
    border-color: ${selected
    ? tokens.colors.midnight[mode === 'light' ? 800 : 200].value
    : tokens.colors.midnight[mode === 'light' ? 200 : 700].value};
    color: ${mode === 'light'
    ? tokens.colors.black[100].value
    : tokens.colors.midnight[200].value};

    /* Text */
    font: inherit;
    text-align: inherit;

    /* Miscellanea */
    cursor: pointer;

    :not([disabled]):hover {
      border-color: ${selected
    ? tokens.colors.midnight[mode === 'light' ? 800 : 200].value
    : tokens.colors.midnight[400].value};
    }
  `};
`;
export const TabsLabelUnderline = styled.button `
  ${({ mode, selected, selectedColor }) => css `
    /* Display & Box Model */
    border: none;
    border-bottom-style: solid;
    border-bottom-width: 4px;
    border-radius: 0;
    margin: 0;
    padding: ${getSpace('m')} ${getSpace('2xl')};

    /* Color */
    background-color: transparent;
    border-bottom-color: ${selected ? selectedColor : 'transparent'};
    color: ${mode === 'light'
    ? tokens.colors.black[100].value
    : tokens.colors.midnight[200].value};

    /* Text */
    font: inherit;
    text-align: inherit;

    /* Miscellanea */
    cursor: pointer;

    :not([disabled]):hover {
      border-bottom-color: ${selected
    ? selectedColor
    : tokens.colors.midnight[400].value};
    }

    :disabled {
      color: ${tokens.colors.midnight[200].value};
    }
  `}
`;
export const TabsLabelsRoot = styled.div `
  ${({ type }) => css `
    /* Display & Box Model */
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;

    ${type !== 'boxed' && `gap: ${getSpace('xs')};`}

    /* Color */
    background-color: transparent;
  `}
`;
export const TabBadge = styled.span `
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.schema.active.light.hard.default.background};
  color: ${({ theme }) => theme.palette.schema.active.light.hard.default.foreground};
`;
//# sourceMappingURL=TabsLabels.styled.js.map